import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { onUpdateSubStep } from "../../reducers/onboardingDataReducer";
import { BasicStep } from "../../types";
import styles from "./DotStep.module.scss";

interface Props {
  currentSubStep: number | null;
  subSteps: BasicStep[] | undefined;
}

const DotStep = ({ currentSubStep, subSteps }: Props) => {
  const { container, dot, filled, disabled } = styles;
  const dispatch = useAppDispatch();

  const { onboardingData, securities, activeTemplate } = useAppSelector(
    (state) => state
  );

  const { lastCompletedSubStep, completedSteps, step } =
    activeTemplate.onboardingType === "SECURITIES"
      ? securities.stepData
      : onboardingData.stepData;

  const disabledSubStep =
    activeTemplate.onboardingType === "SECURITIES"
      ? null
      : onboardingData.stepData.disabledSubStep;

  return (
    <div>
      <div className={container}>
        {currentSubStep &&
          subSteps?.map(({ step: subStep, hideFromSubStepper }) => {
            const isDisabled =
              (disabledSubStep && disabledSubStep === Number(subStep)) ||
              (!completedSteps?.includes(Number(step)) &&
                Number(subStep) > lastCompletedSubStep + 1);
            return hideFromSubStepper ? (
              <></>
            ) : (
              <button
                key={subStep}
                onClick={() => {
                  !isDisabled && dispatch(onUpdateSubStep(Number(subStep)));
                }}
              >
                <div
                  className={`${dot} ${
                    Number(subStep) <= currentSubStep ? filled : ""
                  } ${isDisabled && disabled}`}
                />
              </button>
            );
          })}
      </div>
    </div>
  );
};

export default DotStep;
